// utils/functions/buildVagaPayload.js
import { toDateYYYYMMDD } from '../formatters';

const toDateTimeSQL = (value) => {
  if (!value) return undefined;
  const raw = String(value).trim();
  if (!raw) return undefined;
  if (raw.includes('T')) {
    const [datePart, timePart = '00:00'] = raw.split('T');
    const time = timePart.slice(0, 5);
    return `${datePart} ${time}:00`;
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return `${raw} 00:00:00`;
  return raw;
};

export const buildVagaPayload = (input = {}, { partial = false } = {}) => {
  const out = {};
  const set = (k, v) => {
    if (partial) {
      if (v !== undefined) out[k] = v;
    } else {
      if (v !== undefined) out[k] = v;
    }
  };

  set('Titulo', input.Titulo?.toString().trim());
  set('Endereco', input.Endereco?.toString().trim());
  set('Descricao', input.Descricao?.toString().trim());
  set('DescricaoVaga', input.DescricaoVaga?.toString().trim());

  if (input.Salario !== undefined) {
    const salary =
      typeof input.Salario === 'number'
        ? input.Salario
        : Number(String(input.Salario).replace(',', '.'));
    set('Salario', isNaN(salary) ? undefined : salary);
  }

  if (input.Ativo !== undefined) {
    set('Ativo', Boolean(input.Ativo)); // se backend preferir 1/0 => Number(Boolean())
  }

  if (input.Data_abertura !== undefined) {
    set('Data_abertura', toDateYYYYMMDD(input.Data_abertura));
  }

  if (input.NecessitaCNH !== undefined) {
    const cnh = Number(input.NecessitaCNH);
    set('NecessitaCNH', cnh === 1 ? 1 : 0);
  }

  if (input.EncerramentoAutomatico !== undefined) {
    const encerramento = Number(input.EncerramentoAutomatico);
    set('EncerramentoAutomatico', encerramento === 1 ? 1 : 0);
  }

  if (input.DataEncerramentoAutomatico !== undefined) {
    set('DataEncerramentoAutomatico', toDateTimeSQL(input.DataEncerramentoAutomatico));
  }

  if (input.beneficiosIds !== undefined) {
    set(
      'beneficiosIds',
      Array.isArray(input.beneficiosIds)
        ? input.beneficiosIds.map(Number).filter(Number.isFinite)
        : undefined
    );
  }

  if (input.complementaresIds !== undefined) {
    set(
      'complementaresIds',
      Array.isArray(input.complementaresIds)
        ? input.complementaresIds.map(Number).filter(Number.isFinite)
        : undefined
    );
  }

  return out;
};
